// components/layout/Layout.js (Updated with simplified roles)
import React from 'react';
import AppBar from './AppBar';
import './Layout.css';

/**
 * Layout component that wraps all pages with a consistent structure
 * including the AppBar and content area
 */
const Layout = ({ children, userName }) => {
  return (
    <div className="layout-container">
      <AppBar userName={userName} />
      <main className="layout-content">
        {children}
      </main>
    </div>
  );
};

export default Layout;